<template>
  <DataListStateful
    title="Индексы"
    resource="locations"
    store="locations"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", sortable: false },
        { title: "Индекс", name: "code", sortable: true },
        {
          title: "Страна",
          name: "country",
          dataPath: "Country.Title",
          sortable: true,
        },
        {
          title: "Регион",
          name: "region",
          dataPath: "Region.Title",
          sortable: true,
        },
        {
          title: "Область",
          name: "districts",
          dataPath: "District.Title",
          sortable: true,
        },
        {
          title: "Город",
          name: "city",
          dataPath: "City.Title",
          sortable: true,
        },
        { title: "Адрес", name: "title", sortable: true },
      ],
      filter: {
        code: {
          title: "Индекс",
          type: "text",
        },
        country: {
          title: "Страна",
          type: "reference",
          resource: "countries",
        },
        region: {
          title: "Регион",
          type: "reference",
          resource: "regions",
        },
        district: {
          title: "Область",
          type: "reference",
          resource: "districts",
        },
        city: {
          title: "Город",
          type: "reference",
          resource: "cities",
        },
      },
    };
  },
};
</script>
